export default __webpack_public_path__ + "static/media/canvasAndFramedLargeFramedWood.b4cccc64.jpg";